// https://www.npmjs.com/package/react-scroll
import { Link } from "react-scroll";
// https://react-icons.github.io/react-icons/
import { FiMail } from "react-icons/fi";
import { FaChevronCircleUp } from "react-icons/fa";
import { contactInfo } from "../../data";
import { FaPhoneAlt,FaDownload } from "react-icons/fa";
import { GrMail,GrView } from "react-icons/gr";

const mail = `mailto:${contactInfo.email}`;
const phone = `tel:${contactInfo.phone}`;

const Contact = ({ theme, avatar, name }) => {
  const newTheme = `${theme} d-flex flex-column justify-content-center`;

  return (
    <section id="contact" className={newTheme}>
      <div className="container text-center">
        <h2>Contact</h2>
        <hr />
        <div className="row align-items-center">
          <div className="col-lg-6">
            <img src={avatar} alt={name} />
          </div>
          <div className="col-lg-6">
            <h3>{name}</h3>
            <p>Graduated in "Computer Science & Engineering"</p>
            <p><GrMail /> abusaid.rezoun@gmail.com</p>
            <p><FaPhoneAlt /> +8801788210077</p>
              <a href='mailto:abusaid.rezoun@gmail.com' target="_blank" rel="noreferrer">
                <button type="button" style={{backgroundColor:'tomato'}} className="btn btn-secondary btn-lg">
                  <FiMail /> Contact me
                </button>
              </a>
          </div>
        </div>
        <Link className="scroll" to="about" smooth={true} duration={750}>
          <FaChevronCircleUp id="scroll-up" />
        </Link>
      </div>
    </section>
  );
};

export default Contact;
